import axios from "axios";
import { useState } from "react";
import Swal from "sweetalert2";

const QuickBar = () => {
  const [name, setName] = useState<string>("");
  const [phone, setPhone] = useState<string>("");

  const [loading, setLoading] = useState(false);

  const handlerPostContact = async () => {
    if (!name || !phone) {
      Swal.fire({
        title: "이름, 연락처를 모두 입력해주세요.",
        icon: "error",
      });
      return false;
    }

    if (phone.length !== 11 || !phone.includes("010")) {
      alert("010을 포함한 연락처를 모두 입력해주세요.");
      return false;
    }

    if (!window.confirm("문의 접수를 위한 개인정보 수집에 동의하시나요?")) {
      return false;
    }

    setLoading(true);

    await axios
      .post("/api/contact/quick", {
        name: name,
        phone: phone,
        type: "",
        path: sessionStorage.getItem("path"),
      })
      .then((res) => {
        if (res.data.code === "0000") {
          Swal.fire({
            title: "문의 완료!",
            text: "문의 등록이 완료되었습니다.",
            icon: "success",
          }).then(() => (window.location.href = "/transform"));
        }
      })
      .catch((e) => {
        setLoading(false);
        Swal.fire({
          title: e,
          icon: "error",
        }).then(() => (window.location.href = "/"));
      });
  };

  return (
    <div className="hidden 2xl:block fixed bottom-10 left-0 w-full h-fit px-5 3xl:px-[calc((100%-var(--container))/4)] z-20">
      <div className="relative w-full h-full grid grid-cols-6 items-center gap-3 3xl:gap-5 py-2 bg-white border border-primary shadow-lg rounded-full px-8">
        <div className="col-span-2 relative w-full h-fit grid grid-cols-3 items-center gap-3 3xl:gap-5">
          <div className="text-center">
            <h3 className="font-light">빠른&nbsp;상담요청</h3>
          </div>
          <div className=" relative w-full h-fit col-span-2 flex items-center gap-3 3xl:gap-5">
            <div className=" relative w-1 h-5 border-r border-black"></div>
            <div className="flex items-center relative w-fit h-fit gap-3 3xl:gap-5">
              <h4 className="2xl:text-xl glight leading-none pt-1">문의전화</h4>
              <h3 className="manru 2xl:text-2xl">010.5229.1437</h3>
            </div>
          </div>
        </div>
        <div className="col-span-4 relative w-full h-full grid grid-cols-6 gap-3 3xl:gap-5">
          <input
            type="text"
            placeholder="이름"
            value={name}
            className="bg-black text-white"
            id="name1"
            onChange={(e) => setName(e.target.value)}
          />
          <input
            type="text"
            placeholder="연락처 (010-0000-0000)"
            value={phone}
            className="bg-black text-white col-span-2"
            id="phone1"
            onChange={(e) => setPhone(e.target.value.replace(/[^0-9.]/g, "").replace(/(\..*)\./g, "$1"))}
          />
          <button
            type="button"
            onClick={handlerPostContact}
            disabled={loading}
            className="outline-none custom-btn btn-11 relative w-full sm:w-fit h-fit pt-2 pb-1 px-10 bg-point rounded-full transition-all duration-300"
          >
            <h5 className="glight">전송하기</h5>
          </button>
          <div className="col-span-2">
            <small className="leading-tight relative w-full h-fit pb-0.5 text-[10pt]">
              문의&nbsp;후&nbsp;30분&nbsp;이내에&nbsp;회신이&nbsp;없다면&nbsp;전화문의&nbsp;부탁드립니다.
              <br />
              <div className="flex items-center gap-1">
                <input
                  type="checkbox"
                  name="privacy"
                  id="privacy"
                  defaultChecked
                  checked={true}
                  className="!w-3 !h-3"
                />
                <label htmlFor="privacy">
                  <p className=" text-[10pt]">개인정보처리방침&nbsp;동의</p>
                </label>
              </div>
            </small>
          </div>
        </div>
      </div>
    </div>
  );
};

export default QuickBar;
